'use strict';

angular.module('HRControllers')

.controller('HRController', ['$scope', '$sce', '$q', '$state', '$translate', 'authenticatedUser', 'topBar', function ($scope, $sce, $q, $state, $translate, authenticatedUser, topBar) {

    if ($state.is('HR')) {
        $state.go('HR.confirmations');

        return;
    }

    $scope.authenticatedUser = authenticatedUser;
    $scope.currentIdentity = authenticatedUser.IdentityName;

   // topBar.setTitleAndIcon('History', 'fa-clock-o');

    // Load translations asynchronously to avoid race condition
    $q.all({
        humanResources: $translate('iam.hr.confirmations.breadcrumb.humanResources'),
        history: $translate('iam.hr.confirmations.breadcrumb.history')
    }).then(function(translations) {
        topBar.setTitle($sce.trustAsHtml(
            '<span style="color: #777">' + translations.humanResources + '</span>&nbsp;' +
            '<i style="color: #777" class="fa fa-chevron-right"></i>&nbsp;' +
            '<i class="fa fa-clock-o"></i>&nbsp;' +
            '<span>' + translations.history + '</span>'
        ));
    });
}]);